import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { Autocomplete, CardMedia, Typography } from '@mui/material';
import axios from 'axios'
import { allBusinessType } from '../../services/SignUp'
import { useDispatch } from 'react-redux'
import { nextStep1, nextStep2 } from '../../redux/creates-action/SignUpAction';
import { closeLoadingApi, openLoadingApi } from '../../redux/creates-action/LoadingAction';
import { useSelector } from 'react-redux';
import { endPoint } from '../../config/Config';
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useNotify, Notification } from 'react-admin';
import TokenService from '../../services/TokenService';

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: " 5px 20px",
  borderWidth: 5,
  borderRadius: 4,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",

};

const acceptStyle = {
  borderColor: "#afeeee",
  backgroundColor: "#e0ffff"
};

const rejectStyle = {
  borderColor: "#ff7f50",
  backgroundColor: "#ffe4e1"
};
export default function Step1() {
  const [company, setCompany] = useState('');
  const [legal, setLegal] = useState('');
  const [brand, setBrand] = useState('');
  const [type, setType] = useState([]);
  const [idType, setIdType] = useState(null);
  const [nameType, setNameType] = useState(null);
  const [image, setImage] = useState(null);
  const dispatch = useDispatch()
  const [registered, setRegistered] = useState(false)
  const dataImage = useSelector(state => state.signup.data.image)
  const data1 = useSelector(state => state.signup.data.businessInfo)
  const data2 = useSelector(state => state.signup.data.companyInfo);
  const notify = useNotify();


  const onDrop = useCallback(acceptedFiles => {
    setImage(acceptedFiles[0])
    if (acceptedFiles[0] !== null) {
      let data = new FormData();
      dispatch(openLoadingApi())
      const query = 'mutation($file: Upload!){detectBRC(file: $file){brc name_vn name_en name_short address status error_message}}';
      data.append("operations", JSON.stringify({ query }));
      data.append('map', JSON.stringify({ "0": [("variables.file")] }))
      data.append('0', acceptedFiles[0]);
      axios({
        method: "post",
        url: endPoint,
        data: data,
        headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + TokenService.getLocalAppToken() },
      })
        .then(function (res) {
          const results = res.data.data;
          if (results.detectBRC !== null) {
            setCompany(results.detectBRC.brc)
            setLegal(results.detectBRC.name_vn)
            setBrand(results.detectBRC.name_short)
            setRegistered(false);
            dispatch(closeLoadingApi());
          } else {
            dispatch(closeLoadingApi());
            console.log(res.data.errors);
            setRegistered(true)
            notify(res.data.errors[0].message, { type: 'error' })
          }
        })
        .catch(function (error) {
          console.error(error);
          dispatch(closeLoadingApi())
        })
    }
    else if (dataImage.image === null) {
      setCompany('')
      setLegal('')
      dispatch(closeLoadingApi())
    }
  }, [image])

  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject
  } = useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragReject, isDragAccept]
  );

  useEffect(() => {
    setImage(dataImage.image)
  }, [dataImage.image])

  useEffect(() => {
    allBusinessType().then((result) => {
      setType(result)
    })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  useEffect(() => {
    if (company !== '' && legal !== '' && idType !== '' && nameType !== '' && brand !== '') {
      dispatch(nextStep1(company, legal, brand, idType, nameType, image, registered))
      if (data2.idBrand === '') {
        dispatch(nextStep2(brand, '', '', '', '', '', '', '', '', null, null, null, null));
      }
    }
  }, [company, legal, brand, idType, nameType, image, registered, dispatch])

  useEffect(() => {
    setCompany(data1.company);
    setLegal(data1.legal);
    setIdType(data1.idType);
    setNameType(data1.nameType);
    setImage(data1.image);
    setBrand(data1.brand);
  }, [data1])


  const renderPreviewCardImage = (image) => {
    return (image === null) ? (
      <CardMedia
        component="img"
        image={require('../../assets/images/logo/BlankImage.png')}
        alt="identify-upload"
        sx={{ borderRadius: '10px', height: '285px', }}
      />
    ) : (
      <div style={{
        display: 'block',
        width: '100%',
        height: '285px',
        position: 'relative',
        overflowY: 'scroll',
      }}>
        <CardMedia
          component="img"
          image={URL.createObjectURL(image)}
          alt="identify-upload"
          sx={{
            borderRadius: '10px',
            border: '1px solid #ccc',
            p: 1,
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            position: 'absolute',
            top: '0',
            bottom: '0',
            overflowY: 'scroll',
            left: '0',
            right: '0',
            boxShadow: '0 6px 16px 0 rgb(0 0 0 / 20%)'
          }}
        />
      </div>

    );
  }


  return (
    <React.Fragment>
      <p style={{ textAlign: 'center', margin: '24px 0 48px 0', fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }}>
        {/* Draf & Drop your Business Registration Certificate photo for merchant onboarding */}
      </p>
      <Grid container spacing={5} sx={{ display: 'flex', alignItems: 'stretch' }}>
        <Grid container item xs={12} md={6} >
          <Grid item xs={12} sx={{ mb: 1 }}>
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }} >CompanyID *</label>
            <TextField value={company} disabled variant="outlined" size="large" fullWidth />
          </Grid>
          <Grid item xs={12} sx={{ mb: 1 }} >
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }}>Legal *</label>
            <TextField disabled variant="outlined" size="large" fullWidth value={legal} >
            </TextField>
          </Grid>
          <Grid item xs={12} sx={{ mb: 1 }} >
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Type *</label>
            <FormControl fullWidth>
              <Autocomplete
                isOptionEqualToValue={(option, value) => {
                  return option.id === value?.id
                }}
                value={nameType}
                options={type}
                getOptionLabel={(option) => option.content}
                onChange={(e, newValue) => {
                  setIdType(newValue === null ? '' : newValue.id)
                  setNameType(newValue)
                }}
                renderInput={(params) => <TextField {...params} placeholder="Select..." />}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} item xs={12} md={6}>
          <Grid item xs={12}>
            {renderPreviewCardImage(image)}
          </Grid>
          <Grid item xs={12}>
            <div >
              <div {...getRootProps({ className: "dropzone", style })}>
                <input {...getInputProps()} />
                <CloudUploadIcon sx={{ fontSize: '30px', color: '#afeeee' }}></CloudUploadIcon>
                <Typography sx={{ cursor: 'pointer', }}>
                  Drag & Drop your file here
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Notification />
    </React.Fragment>
  );
}